'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactackleCore = require('reactackle-core');

exports.default = {
  tabs: {
    style: {
      light: {
        backgroundColor: _reactackleCore.colorTransparent
      },

      dark: {
        backgroundColor: _reactackleCore.colorTransparent
      }
    }
  },

  tab: {
    fontSize: _reactackleCore.fontSizeBody,
    lineHeight: 1.25,
    textTransform: 'uppercase',
    paddingX: (0, _reactackleCore.bmodule)(1.5),
    paddingY: (0, _reactackleCore.bmodule)(1),
    minHeight: (0, _reactackleCore.bmodule)(6),
    minWidth: 120,
    maxWidth: 320,

    style: {
      light: {
        fontColor: _reactackleCore.bodyFontColorAlt,
        backgroundColor: _reactackleCore.colorTransparent,
        fontWeight: _reactackleCore.fontWeightNormal,
        opacity: 0.8,

        hover: {
          fontColor: _reactackleCore.bodyFontColorAlt,
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          fontWeight: _reactackleCore.fontWeightNormal,
          opacity: 0.9
        },

        focus: {
          fontColor: _reactackleCore.bodyFontColorAlt,
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          fontWeight: _reactackleCore.fontWeightNormal,
          opacity: 1
        },

        selected: {
          fontColor: _reactackleCore.bodyFontColorAlt,
          backgroundColor: _reactackleCore.colorTransparent,
          fontWeight: _reactackleCore.fontWeightSemibold,
          opacity: 1
        }
      },

      dark: {
        fontColor: _reactackleCore.bodyFontColor,
        backgroundColor: _reactackleCore.colorTransparent,
        fontWeight: _reactackleCore.fontWeightNormal,
        opacity: 0.8,

        hover: {
          fontColor: _reactackleCore.bodyFontColor,
          backgroundColor: 'rgba(0, 0, 0, 0.1)',
          fontWeight: _reactackleCore.fontWeightNormal,
          opacity: 0.9
        },

        focus: {
          fontColor: _reactackleCore.bodyFontColor,
          backgroundColor: 'rgba(0, 0, 0, 0.1)',
          fontWeight: _reactackleCore.fontWeightNormal,
          opacity: 1
        },

        selected: {
          fontColor: _reactackleCore.bodyFontColor,
          backgroundColor: _reactackleCore.colorTransparent,
          fontWeight: _reactackleCore.fontWeightSemibold,
          opacity: 1
        }
      }
    }
  },

  icon: {
    height: 40,
    width: null,
    imgSize: null,
    iconTextSpacing: (0, _reactackleCore.bmodule)(1),

    style: {
      light: {
        color: 'inherit',

        hover: {
          color: 'inherit'
        },

        focus: {
          color: 'inherit'
        },

        selected: {
          color: 'inherit'
        }
      },

      dark: {
        color: 'inherit',

        hover: {
          color: 'inherit'
        },

        focus: {
          color: 'inherit'
        },

        selected: {
          color: 'inherit'
        }
      }
    }
  },

  bar: {
    thickness: 4,

    style: {
      light: {
        backgroundColor: _reactackleCore.colorMain
      },

      dark: {
        backgroundColor: _reactackleCore.colorMain
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-tabs/dist/styles/theme.js
// module id = 826
// module chunks = 0